var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 47,
    viewBox: "0 0 44 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_322_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83645 18.7157C9.70667 21.1423 9.856 23.7254 7.63912 25.3506C7.12943 25.7236 6.71584 26.2077 6.43128 26.7645C6.14671 27.3213 5.99904 27.9353 6 28.5578C6 30.2908 7.39023 31.7683 9.2 31.7683H34.8C36.6098 31.7683 38 30.2908 38 28.5578C38 27.2958 37.392 26.1068 36.3609 25.3506C34.144 23.7254 34.2933 21.1423 34.1636 18.7157C34.0036 15.6669 32.6523 12.7946 30.3887 10.692C28.1251 8.58936 25.1222 7.41699 22 7.41699C18.8778 7.41699 15.8749 8.58936 13.6113 10.692C11.3477 12.7946 9.99643 15.6669 9.83645 18.7157Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3337 31.7684C27.3337 33.1514 26.7718 34.4779 25.7716 35.4558C24.7714 36.4338 23.4148 36.9832 22.0003 36.9832C20.5858 36.9832 19.2293 36.4338 18.2291 35.4558C17.2289 34.4779 16.667 33.1514 16.667 31.7684M19.3337 4.17333C19.3337 5.61262 20.5283 7.43259 22.0003 7.43259C23.4723 7.43259 24.667 5.61262 24.667 4.17333C24.667 2.73404 23.4723 2.21777 22.0003 2.21777C20.5283 2.21777 19.3337 2.73404 19.3337 4.17333Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_322_22",
    x: 0.599609,
    y: 0.817383,
    width: 42.8008,
    height: 45.5654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_322_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_322_22",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoting);
export default __webpack_public_path__ + "static/media/Noting.9697d41e17a88ac44b94648f8708a01b.svg";
export { ForwardRef as ReactComponent };